import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { commercialConstants } from 'app/common/commercial-constants';
@Component({
    selector: 'is-submission-failed',
    templateUrl: './submission-failed.component.html',
    styleUrls: ['./submission-failed.component.scss'],
    standalone: false
})
export class SubmissionFailedComponent {
    description: string;
    constructor(
        private dialogReference: MatDialogRef<SubmissionFailedComponent>,
        @Inject(MAT_DIALOG_DATA) data,
        private router: Router) {
        this.description = data.description;
    }
    close(): void {
        this.dialogReference.close();
        this.router.navigate([commercialConstants.URLS.pakClaimsList]);
    }
}
